// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4365":"274b7d98","4447":"e9af5c3b","6346":"b72a8383","7418":"91250f96","8621":"ef600583"}[chunkId] + ".chunk.css";
};